import * as React from "react";
import { cn } from "../../lib/utils";

const Separator = React.forwardRef(
  (
    { 
      className, 
      orientation = "horizontal", 
      decorative = true,
      variant = "default",
      ...props 
    },
    ref
  ) => {
    const Component = decorative ? "div" : "hr";

    // Base classes for each variant and orientation
    const getBaseClasses = () => {
      if (variant === "dashed") {
        return orientation === "horizontal" 
          ? "h-0 w-full border-t border-dashed border-gray-300"
          : "w-0 h-full border-l border-dashed border-gray-300";
      }
      
      if (variant === "dotted") {
        return orientation === "horizontal"
          ? "h-0 w-full border-t border-dotted border-gray-300" 
          : "w-0 h-full border-l border-dotted border-gray-300";
      }
      
      // Default variant - using background color
      return orientation === "horizontal"
        ? "h-px w-full bg-gray-300"  // Default gray background
        : "w-px h-full bg-gray-300";
    };

    return (
      <Component
        ref={ref}
        role={decorative ? "separator" : undefined}
        aria-orientation={orientation}
        className={cn(
          "shrink-0",
          getBaseClasses(),
          className // Custom classes override defaults
        )}
        {...props}
      />
    );
  }
);

Separator.displayName = "Separator";

export { Separator };